import React, { useEffect } from "react";
import {
  MOZZOAPP_INSTITUTIONAL_LOGO_URL,
  applyInstitutionalBrandingAssets,
} from "../../services/local/institutionalBranding";

function KioskAndroidLanding() {
  useEffect(() => {
    document.title = "Mozzo Kiosk";
    applyInstitutionalBrandingAssets();
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img
          src={MOZZOAPP_INSTITAL_LOGO_FALLBACK}
          alt="Mozzo"
          style={styles.logo}
        />
        <div style={styles.eyebrow}>Mozzo Kiosk</div>
        <h1 style={styles.title}>Tablet lista para vincular</h1>
        <p style={styles.subtitle}>
          La APK ya puede correr en esta tablet. Para dejarla apuntando a un totem
          puntual, vuelve al panel de MozzoApp y abre el launcher del kiosk correcto.
        </p>

        <div style={styles.instructionsBox}>
          <div style={styles.instructionsTitle}>Sigue estos pasos</div>
          <ol style={styles.list}>
            <li>Vuelve a la ventana del navegador donde abriste "Launcher Android".</li>
            <li>Si todavia no lo hiciste, descarga e instala la APK desde ese panel.</li>
            <li>Despues toca "Abrir launcher" o escanea el QR del totem que corresponda.</li>
            <li>Cuando Android lo pregunte, elige abrir ese link con Mozzo Kiosk.</li>
          </ol>
        </div>

        <div style={styles.callout}>
          Una vez vinculada, la app va a recordar ese puesto y abrira directo ahi cada vez
          que prendas la tablet.
        </div>

        <button type="button" onClick={() => window.location.reload()} style={styles.button}>
          Reintentar
        </button>
      </div>
    </div>
  );
}

const MOZZOAPP_INSTITAL_LOGO_FALLBACK = MOZZOAPP_INSTITUTIONAL_LOGO_URL;

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    background:
      "radial-gradient(circle at top, rgba(59,130,246,0.14), transparent 40%), linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)",
  },
  card: {
    width: "min(560px, 100%)",
    display: "grid",
    gap: "18px",
    justifyItems: "center",
    padding: "28px",
    borderRadius: "28px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(148, 163, 184, 0.22)",
    boxShadow: "0 30px 70px rgba(15, 23, 42, 0.12)",
    textAlign: "center",
  },
  logo: {
    width: "84px",
    height: "84px",
    objectFit: "contain",
  },
  eyebrow: {
    color: "#2563eb",
    fontSize: "12px",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },
  title: {
    margin: 0,
    color: "#0f172a",
    fontSize: "34px",
    lineHeight: 1.05,
  },
  subtitle: {
    margin: 0,
    color: "#475569",
    fontSize: "16px",
    lineHeight: 1.65,
  },
  instructionsBox: {
    width: "100%",
    display: "grid",
    gap: "10px",
    padding: "18px",
    borderRadius: "18px",
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    textAlign: "left",
  },
  instructionsTitle: {
    color: "#1d4ed8",
    fontWeight: 800,
  },
  list: {
    margin: 0,
    paddingLeft: "20px",
    color: "#1e3a8a",
    lineHeight: 1.7,
    display: "grid",
    gap: "6px",
  },
  callout: {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "16px",
    backgroundColor: "#fff7ed",
    border: "1px solid #fed7aa",
    color: "#9a3412",
    lineHeight: 1.6,
  },
  button: {
    border: "none",
    borderRadius: "14px",
    padding: "12px 18px",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    fontWeight: 700,
    cursor: "pointer",
  },
};

export default KioskAndroidLanding;
